import React, { useState } from 'react'
import { injectIntl, IntlShape, InjectedIntlProps } from 'react-intl'
import { RightCircleFilled } from '@ant-design/icons'
import AntdTooltip from 'UI/Tooltip/Tooltip'
import styles from './Navigation.scss'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { navigationTooltipProps, NavigationTooltipWrapper } from './utils'
import { useNavigationLinks } from './useNavigationLinks'

type NavigationProps = InjectedIntlProps & {
  intl: IntlShape
}

const Navigation: React.FC<NavigationProps> = ({ intl }) => {
  const links = useNavigationLinks()
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <nav className={classNames(styles.container, { [styles.expanded]: isExpanded })} data-expanded={`${isExpanded}`}>
      <AntdTooltip {...navigationTooltipProps} title={isExpanded ? 'Close Navigation' : 'Open Navigation'}>
        <button
          className={styles.expandButton}
          style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.25s ease' }}
          onClick={e => {
            e.stopPropagation()
            setIsExpanded(prev => !prev)
          }}
        >
          <RightCircleFilled style={{ color: '#1890FF' }} />
        </button>
      </AntdTooltip>
      <ul className={styles.links}>
        {links.map(({ title, path, onClick, iconUrl }) => (
          <li key={path} className={classNames(styles.link, { [styles.selected]: location.pathname === path })}>
            <NavigationTooltipWrapper isExpanded={isExpanded} title={title}>
              <NavLink to={path} onClick={onClick} className={styles.button}>
                {iconUrl && <img id={`nav-${title}`} src={iconUrl} alt={title} className={styles.icon} />}
                {isExpanded && <span className={styles.title}>{title}</span>}
              </NavLink>
            </NavigationTooltipWrapper>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default injectIntl(Navigation)
